import {
  FAQ_OPERATOR_START,
  FAQ_OPERATOR_SUCCESS,
  FAQ_OPERATOR_ERROR,
} from "Constant";

const initialState = {
  loading: false,
  data: [],
};

export default function faqOperatorReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case FAQ_OPERATOR_START:
      return {
        ...state,
        loading: true,
      };
    case FAQ_OPERATOR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FAQ_OPERATOR_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
